import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';
import { DeviceStatus } from '@shure/shared/angular/data-access/system-api/models';

import { DeviceNameCellData } from './device-name-renderer.component';

export function areDeviceNameCellsEqual(
	a?: DeviceNameCellData | null | undefined,
	b?: DeviceNameCellData | null | undefined
): boolean {
	const aData = a ?? getDefaultDeviceNameCellData();
	const bData = b ?? getDefaultDeviceNameCellData();

	return (
		aData.id === bData.id &&
		aData.model === bData.model &&
		aData.status === bData.status &&
		aData.isVirtual === bData.isVirtual &&
		aData.isPasswordEnabled === bData.isPasswordEnabled &&
		aData.isAuthenticated === bData.isAuthenticated &&
		aData.channelCount === bData.channelCount &&
		aData.authenticatedState === bData.authenticatedState &&
		aData.name?.name === bData.name?.name &&
		aData.name?.isDisabled === bData.name?.isDisabled &&
		aData.name?.maxLength === bData.name?.maxLength &&
		((aData.identify == null && bData.identify == null) ||
			(aData.identify != null &&
				bData.identify != null &&
				aData.identify.isDisabled === bData.identify.isDisabled &&
				aData.identify.isIdentifying === bData.identify.isIdentifying))
	);
}

function getDefaultDeviceNameCellData(): DeviceNameCellData {
	return {
		id: '',
		model: DeviceModel.UNKNOWN,
		status: DeviceStatus.Offline,
		isVirtual: false,
		isPasswordEnabled: false,
		isAuthenticated: false,
		channelCount: undefined,
		authenticatedState: undefined,
		name: {
			name: '',
			isDisabled: false,
			maxLength: 31
		},
		identify: {
			isDisabled: false,
			isIdentifying: false
		}
	};
}
